module.exports = __webpack_public_path__ + "img/del.a30bb7b5.png";